/* Bluebells - CVP option prices
   Several swatch-table options carry their upcharge inside name_override
   ("GLUTEN FREE Carrot + $10"). That reads as part of the flavour name and
   wraps badly in a narrow card, so the suffix is taken off the visible label
   and the price is drawn right-aligned on the same line instead.

   Display only: the radio's value, and therefore the cart property and every
   job sheet and report downstream, is left exactly as it was. The amount
   comes from the input's data-price-cents where the CVP has resolved it
   (the real child-product price), falling back to the number in the text. */
(function () {
  'use strict';

  var SEL = '.atlas-cvp__table-title, .atlas-cvp__multiqty-title, .atlas-cvp__swatch-label';
  var ROW = '.atlas-cvp__table-row, .atlas-cvp__multiqty-item, .atlas-cvp__swatch';
  var SUFFIX = /\s*\+\s*\$\s*(\d+(?:[.,]\d{1,2})?)\s*$/;
  var DONE = 'data-bb-priced';

  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function centsFor(el, parsed) {
    var row = el.closest && el.closest(ROW);
    var inp = row && row.querySelector('input[data-price-cents]');
    var c = inp ? parseInt(inp.getAttribute('data-price-cents'), 10) : 0;
    return c > 0 ? c : parsed;
  }

  function tag(el) {
    if (el.getAttribute(DONE)) return;
    var txt = el.textContent || '';
    var m = txt.match(SUFFIX);
    /* mark either way - an option with no price never needs looking at again,
       and the CVP re-renders these lists often */
    el.setAttribute(DONE, '1');
    if (!m) return;

    var parsed = Math.round(parseFloat(m[1].replace(',', '.')) * 100) || 0;
    var name = document.createElement('span');
    name.className = 'bb-cvp-optname';
    name.textContent = txt.replace(SUFFIX, '');
    var price = document.createElement('span');
    price.className = 'bb-cvp-optprice';
    price.textContent = money(centsFor(el, parsed));

    el.textContent = '';
    el.appendChild(name);
    el.appendChild(price);
    el.classList.add('bb-cvp-hasprice');
  }

  function run() {
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) tag(list[i]);
  }

  function styles() {
    if (document.getElementById('bb-cvp-price-css')) return;
    var s = document.createElement('style');
    s.id = 'bb-cvp-price-css';
    s.textContent =
      '.bb-cvp-hasprice{display:flex !important;align-items:baseline;gap:12px;width:100%;align-self:stretch;}' +
      '.bb-cvp-optname{flex:1 1 auto;min-width:0;font:inherit !important;color:inherit;}' +
      '.bb-cvp-optprice{flex:0 0 auto;margin-left:auto;white-space:nowrap;font:inherit !important;color:inherit;}';
    document.head.appendChild(s);
  }

  function boot() {
    if (!document.querySelector('.atlas-cvp, [data-cvp], .atlas-cvp__table')) {
      /* the picker mounts after us on some templates - keep looking briefly */
    }
    styles();
    run();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; run(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
    /* belt and braces for a picker that swaps nodes without us seeing it */
    var n = 0;
    var iv = setInterval(function () { run(); if (++n > 20) clearInterval(iv); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
